import { render, staticRenderFns } from "./NewsletterComponent.vue?vue&type=template&id=3354f65f&scoped=true"
import script from "./NewsletterComponent.vue?vue&type=script&lang=js"
export * from "./NewsletterComponent.vue?vue&type=script&lang=js"
import style0 from "./NewsletterComponent.vue?vue&type=style&index=0&id=3354f65f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3354f65f",
  null
  
)

export default component.exports